import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {KfRegistrationComponent} from './containers/kf-registration/kf-registration.component';
import {KfConfigurationEditComponent} from './containers/kf-configuration-edit/kf-configuration-edit.component';
import {KfConfigurationComponent} from './containers/kf-configuration/kf-configuration.component';
import {KfRegistrationEditComponent} from './components/kf-registration-edit/kf-registration-edit.component';
import {KfConfigurationMappingComponent} from './containers/kf-configuration-mapping/kf-configuration-mapping.component';
import {KfDataEntryGuard} from './guards/kf-data-entry.guard';

const routes: Routes = [
  { path: 'kfreporting/kfconfiguration/mappings', canActivate: [KfDataEntryGuard], component: KfConfigurationMappingComponent },
  { path: 'kfreporting/kfconfiguration/summary-mappings', canActivate: [KfDataEntryGuard], component: KfConfigurationMappingComponent },
  {
    path: 'kfdataentry/country', canActivate: [KfDataEntryGuard],
    children: [
      {path: 'kfconfiguration', children: [
          {path: '', component: KfConfigurationComponent},
          {path: ':year', component: KfConfigurationEditComponent}
        ]
      },
      {path: 'kfregistration', children: [
          {path: 'all', component: KfRegistrationComponent},
          {path: 'putonmarket', component: KfRegistrationComponent},
          {path: 'collected', component: KfRegistrationComponent},
          {path: ':keyFigure/:year', component: KfRegistrationEditComponent}
        ]
      }
    ]
  },
  {
    path: 'kfdataentry/weeesystem', canActivate: [KfDataEntryGuard],
    children: [
      {path: 'kfconfiguration', children: [
          {path: '', component: KfConfigurationComponent},
          {path: ':year', component: KfConfigurationEditComponent}
        ]
      },
      {path: 'kfregistration', children: [
          {path: 'all', component: KfRegistrationComponent},
          {path: 'putonmarket', component: KfRegistrationComponent},
          {path: 'collected', component: KfRegistrationComponent},
          {path: 'cost', component: KfRegistrationComponent},
          {path: 'recycling', component: KfRegistrationComponent},
          {path: ':keyFigure/:year', component: KfRegistrationEditComponent}
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class KfDataEntryRoutingModule {}
